import { AirbnbPassThroughOccupancyTax, AirbnbPricingRule, AirbnbStandardFeeType } from '@tokeet-frontend/channels'
import { ChannelNameTokens } from '@tokeet/tv3-platform'

export interface LinkConnectionWithRentalPayload {
  channelId: string
  propertyId: string | number
  roomId: string | number
  rentalId: string
}

export type UnlinkConnectionWithRentalPayload = LinkConnectionWithRentalPayload

export interface AddImportedCalendarConnectionPayload {
  rentalid: string // rental id
  sendto: string // email
  name: string // calendar name
  calendar: string // calendar url
  book: boolean //
  attributes?: any
}

export interface AddExportedCalendarConnectionPayload {
  rental_id: string
  id: string // channel id
  name: string // channel.name,
  agent: string // channel.agent,
  type: string // channel.type,
  rental_name: string
  channel_rental_id: string // channel.channelId + '-' + rental.pkey,
  ref_id: string
  url: string // 'https://calendars.tokeet.com/calendar/rental/'+rental.account+'/'+ rental.pkey +'?ref_id=' + (refId || '')
}

export interface RefreshImportedCalendarConnectionPayload {
  name: string // connection name
  calendar: string // url
  rentalid: string // rental id
  sendto: string // rental email
}

export interface ApiConnectionStatus {
  room?: number
  channel?: string
  account?: number
  property?: number
  lastratepush?: number
  lastavailpull?: number
  lastavailpush?: number
  loginfail?: number
  status?: string
}

export interface GetChannelRoomRatesPayload {
  api: string
  channel_id: string
  id: string | number // room id
  propertyId: string | number
}

export interface ChannelRoomRateResponse {
  fixed_oc: number
  id: string
  max_per: string
  name: string
  policy: string
  policyid: string
  readonly: number
}

export interface PushRatesToApiConnectionPayload {
  category?: string
  rateid?: string
  maxguest?: number
  pricemodel?: string
  roomId: string | number
  propertyId?: string | number
  rental_id?: string
  maxPersons?: number
}

export interface ChannelRoomsResponse {
  api: string
  channel_id: string
  created_date: number
  description: string
  hotelName: string
  id: string
  roomId: string
  name: string
  propertyId: string
  rental_id: string
}

export function channelRoomToConnectionPlainObject(room: ChannelRoomsResponse) {
  return {
    channel_id: room.channel_id,
    created: room.created_date,
    lastsync: undefined,
    linkDate: room.created_date,
    name: room.api,
    propertyId: room.propertyId,
    propertyName: room.hotelName,
    rental_id: room.rental_id,
    roomId: room.roomId || room.id,
    roomName: room.name,
    status: 1,
    type: 'API',
  }
}

export interface CreateChannelListingPayload {
  rental_id: string
  propertyId: string | number
  channelId: string
  api: ChannelNameTokens
}

export interface AirBnBBookingPrefResponse {
  metadata: any
  availability_rule: {
    min_days_notice: { days: number }
    max_days_notice: { days: number }
    turnover_days: { days: number }
    listing_id: number
    day_of_week_check_in: { day_of_week: number }[]
    default_min_nights: number
    default_max_nights: number
    booking_lead_time: { hours: number }
    day_of_week_check_out: { day_of_week: number }[]
    day_of_week_min_nights: {
      day_of_week: number
      min_nights: number
    }[]
    seasonal_min_nights: {
      start_date: string //  "2020-12-01",
      end_date: string //  "2020-12-31",
      min_nights: number //  5
    }[]
    allow_rtb_above_max_nights: boolean
  }
}

export interface AirBnBPriceSettingsResponse {
  weekend_price: number
  price_per_extra_person: number
  listing_id: number
  default_daily_price: number
  guests_included: number
  listing_currency: string
  monthly_price_factor: number
  cleaning_fee: number
  weekly_price_factor: number
  standard_fees: AirbnbPricingStandardFee[]
  security_deposit: number
  pass_through_taxes: AirbnbPassThroughOccupancyTax[]
  default_pricing_rules: AirbnbPricingRule[]
  pass_through_taxes_collection_type: string
}

export type AirbnbTaxAmountType =
  | 'percent_per_reservation'
  | 'flat_per_guest'
  | 'flat_per_guest_per_night'
  | 'flat_per_night'

export interface AirBnBUpdateBookingPrefPayload {
  channelId: string
  propertyId: number
  roomid: number
  minleadtime: number
  turnover: number
  maxleaddays: number
  minstay: number
  maxstay: number
}

export interface AirbnbPricingStandardFee {
  fee_type: AirbnbStandardFeeType
  amount_type: 'percent' | 'flat'
  amount: number
  charge_type: 'PER_GROUP' //  | 'PER_PERSON'
}

export interface AirBnBUpdatePriceSettingsPayload {
  channelId: string
  propertyId: number
  roomid: number
  listing_id: number

  listing_currency: string
  default_daily_price: number // $
  weekend_price: number // $
  security_deposit: number // $
  cleaning_fee: number // $
  guests_included: number // 1 - 90
  price_per_extra_person: number // $
  monthly_price_factor: number // 0 - 100 %
  weekly_price_factor: number // 0 - 100 %
  standard_fees: AirbnbPricingStandardFee[]
  pass_through_taxes: AirbnbPassThroughOccupancyTax[]
  eligible_for_pass_through_taxes: boolean
  pass_through_taxes_collection_type: 'INELIGIBLE'
}
